module.exports = __webpack_public_path__ + "static/media/rejectIcon.0ab11548.svg";